import {Component, OnInit} from '@angular/core';
import {FormControl, Validators} from '@angular/forms';
import {LicenseService} from '../license.service';

@Component({
  selector: 'app-license',
  templateUrl: './license.component.html',
  styleUrls: ['./license.component.css', '../../assets/css/button.css', '../../assets/css/label.css'
    , '../../assets/css/grid.css', '../../assets/css/containers.css', '../../assets/css/textfield.css'
    , '../../assets/css/checkbox.css', '../../assets/css/CGM-G3Symbols.css']
})
export class LicenseComponent implements OnInit {

  public PROXY_API = window.location.origin + '/proxy';
  showPassword: boolean;
  agreeToCookieUse: boolean;
  showCookieError: boolean;
  showInvalidLicenseKey: boolean;
  showLicenseException: boolean;
  licenseFormControl = new FormControl(null, Validators.required);


  constructor(private licenseService: LicenseService) {
    this.showPassword = false;
    this.showInvalidLicenseKey = false;
    this.showLicenseException = false;
    this.agreeToCookieUse = false;
  }

  submitLicense() {

    this.showInvalidLicenseKey = false;
    this.showLicenseException = false;
    if (this.agreeToCookieUse && this.licenseFormControl.valid) {
      this.licenseService.submitLicense(this.licenseFormControl.value)
        .subscribe(value => {

          if (value && value.length > 0) {
            console.log(value);
            window.location.reload();
          } else {
            this.showInvalidLicenseKey = true;
          }
        }, error => {
          this.showLicenseException = true;
          console.log(error);
        });
    } else {
      this.showCookieError = true;
    }
  }

  hideCookieError() {
    if (this.agreeToCookieUse) {
      this.showCookieError = false;
    }
  }

  ngOnInit(): void {
  }
}
